import { httpsCallable } from 'firebase/functions';
import type {
  AdminUser,
  CreateAdminUserRequest,
  Role,
  SyncManatalJobsResult,
  TranslateBlogPostRequest,
  TranslateBlogPostResponse,
} from '@hrlabs/shared-types';
import { functions } from './firebase';

export const syncManatalJobs = httpsCallable<void, SyncManatalJobsResult>(
  functions,
  'syncManatalJobs',
);

export const translateBlogPost = httpsCallable<
  TranslateBlogPostRequest,
  TranslateBlogPostResponse
>(functions, 'translateBlogPost');

export const setUserRoleClaim = httpsCallable<{ uid: string; role: Role }, { ok: true }>(
  functions,
  'setUserRoleClaim',
);

export const listAdminUsers = httpsCallable<void, { users: AdminUser[] }>(
  functions,
  'listAdminUsers',
);

export const createAdminUser = httpsCallable<CreateAdminUserRequest, { uid: string }>(
  functions,
  'createAdminUser',
);

export const deleteAdminUser = httpsCallable<{ uid: string }, { ok: true }>(
  functions,
  'deleteAdminUser',
);
